export default __webpack_public_path__ + "static/media/profile.f368af56.png";